import ClearIcon from '@mui/icons-material/Clear';
import { FormControl, IconButton, InputAdornment, InputLabel, MenuItem, Select, SelectProps } from '@mui/material';
import HelperText from 'component/Input/HelperText';
import _ from 'lodash';
import { useRef, useState } from 'react';

interface SelectInputProps extends Omit<SelectProps, 'onChange'> {
    onChange: (e: any) => void;
    options: any[];
    value?: string | string[] | number;
    disabled?: boolean;
    sxMenuItem?: any;
    label?: string;
    helperText?: string;
    width?: any;
    height?: string | number;
    dropdown?: boolean;
    disabledMenuItem?: boolean
    defaultValue?: string | number | string[];
    required?: boolean;
    loading?: boolean;
    onOpen?: () => void;
    onClear?: boolean;
    onScrollEnd?: () => void;
    placeholder?: any
}

export default function SelectInput(props: SelectInputProps) {
    const componentRef: any = useRef(null)
    const [isFocused, setIsFocused] = useState(false);

    const handleFocus = () => setIsFocused(true);
    const handleBlur = () => setIsFocused(false);

    const handleClear = (e: React.MouseEvent) => {
        e.stopPropagation();
        if (props.onChange) {
            props.onChange({ target: { value: props.dropdown ? [] : '' } });
        }
    };

    const handleListScroll = (e: React.UIEvent<HTMLElement>) => {
        const el = e.currentTarget;
        if (el.scrollTop + el.clientHeight >= el.scrollHeight - 1) {
            if (!props.loading && props.onScrollEnd) {
                props.onScrollEnd();
            }
        }
    };

    return (
        <FormControl ref={componentRef} sx={{ width: props.width || '100%', height: props.height, }} size="small" disabled={props.disabled}>
            <InputLabel id="demo-select-small-label"
                sx={{
                    color: props.helperText ? '#B00020' : '#808080',
                    '&.Mui-focused': {
                        color: props.helperText ? '#B00020' : '#1CB99A'
                    },
                }}
            // shrink={!(props.value === '' || props.value === 0)}
            >
                {props.label} {props.required && <span style={{ color: (props.value || isFocused) ? 'red' : 'gray' }}>*</span>}
            </InputLabel>
            <Select
                error={props.helperText !== '' && props.helperText !== undefined}
                onChange={(e) => {
                    const value = e.target.value;
                    // หา option ที่ match
                    const selectedOption = _.find(props.options, (opt) => opt.value === value);

                    if (props.onChange) {
                        props.onChange({
                            target: {
                                value,
                                name: selectedOption?.name, // ✅ ส่ง name กลับไปด้วย
                                option: selectedOption      // ✅ จะได้ object ทั้งก้อน
                            }
                        });
                    }
                }}
                defaultValue={props.defaultValue}
                value={props.value}
                placeholder={props.placeholder}
                multiple={props.dropdown}
                onOpen={props.onOpen}
                onFocus={handleFocus}
                onBlur={handleBlur}
                inputProps={{ value: props.value }}
                endAdornment={
                    props.onClear ? props.value && !props.disabled ? (
                        <InputAdornment position="end" style={{ marginRight: '8px' }}>
                            <IconButton
                                aria-label="clear"
                                onClick={handleClear}
                                edge="end"
                                size="small"
                                tabIndex={-1}
                            >
                                <ClearIcon fontSize="small" />
                            </IconButton>
                        </InputAdornment>
                    ) : null
                        : null

                }
                MenuProps={{
                    disableScrollLock: true,
                    disableAutoFocusItem: true,
                    PaperProps: {
                        sx: {
                            maxHeight: 400,
                            overflowY: 'auto'
                        },
                        onScroll: handleListScroll
                    },
                    MenuListProps: {
                        onScroll: handleListScroll
                    }
                }}
                sx={{
                    backgroundColor: props.disabled ? '#F0F0F0' : '#FFFFFF',
                    height: props.height,
                    minHeight: props.height,
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#1CB99A',
                        borderWidth: '1px'
                    },
                    '&.Mui-error .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#B00020',
                    },
                    '&.Mui-disabled': {
                        borderColor: '#C5C5C5',
                    },
                }}>
                {props.loading ? <MenuItem disabled>กำลังโหลด...</MenuItem> : props.dropdown ? props.options : _.map(props.options, (item, index) => <MenuItem sx={
                    {
                        width: componentRef.current?.offsetWidth - 16,
                        whiteSpace: 'normal', // ทำให้ข้อความขึ้นบรรทัดใหม่ได้
                        overflowWrap: 'break-word', // ช่วยให้คำที่ยาวเกินขอบเขตถูกแบ่ง
                        "&.Mui-focusVisible": {
                            backgroundColor: '#FFFFFF'
                        },
                        '&:hover': {
                            backgroundColor: '#EBF2F0',
                        },
                        '&.Mui-selected.Mui-focusVisible': {
                            backgroundColor: '#EBF2F0',
                        },
                        '&.Mui-selected': {
                            backgroundColor: '#EBF2F0',
                        },
                        '&.Mui-selected:hover': {
                            backgroundColor: '#EBF2F0',
                        },
                    }
                } key={index} disabled={item.disabled} value={item.value}>{item.name}</MenuItem>)}
            </Select>
            {props.helperText && <HelperText label={props.helperText}></HelperText>}
        </FormControl >
    )

}
